import { Injectable } from "@angular/core";
import { BfxBaseBlotterFilteringService } from "../../bfx-base-blotter/bfx-base-blotter-filtering.service";
import {
  ActiveUserProfilePromiseService,
  ClientPromiseLookupService,
  CcyPairPromiseLookupService,
  CurrencyPairGroupPromiseLookupService,
  InterventionTableDefinitionFactory,
} from "shared/cubiq-services";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxBlotterInterventionFilterService extends BfxBaseBlotterFilteringService {
  constructor(
    protected tableDefinitionFactory: InterventionTableDefinitionFactory,
    protected activeUserService: ActiveUserProfilePromiseService,
    protected clientService: ClientPromiseLookupService,
    protected currencyPairService: CcyPairPromiseLookupService,
    protected currencyPairGroupService: CurrencyPairGroupPromiseLookupService,
  ) {
    super(
      tableDefinitionFactory,
      activeUserService,
      clientService,
      currencyPairService,
      currencyPairGroupService,
    );
  }
}
